import { LoaderCircle } from "lucide-react";
import { Logo } from "./logo";

export function LoadingScreen() {
  return (
    <main
      className="grid min-h-screen place-items-center bg-slate-50"
      aria-busy="true"
      aria-label="Loading Master Notes"
    >
      <div className="flex flex-col items-center gap-5">
        <Logo />
        <LoaderCircle className="size-6 animate-spin text-indigo-600" />
      </div>
    </main>
  );
}
